import axios from 'axios';

const BASE = `${process.env.REACT_APP_API_BASE_URL}connection_requests/`;

const post = (method, userId, fields = {}) => {
  const payload = new FormData();
  payload.append('id', userId);
  Object.entries(fields).forEach(([key, value]) => {
    payload.append(key, value == null ? '' : value);
  });
  return axios.post(`${BASE}${method}`, payload).then((res) => res.data || {});
};

export const sendConnectionRequest = (userId, receiverId, message) =>
  post('send', userId, { receiver_id: receiverId, message });

export const fetchReceivedRequests = (userId) => post('inbox', userId);

export const fetchSentRequests = (userId) => post('sent', userId);

export const acceptConnectionRequest = (userId, requestId) =>
  post('accept', userId, { request_id: requestId });

export const declineConnectionRequest = (userId, requestId) =>
  post('decline', userId, { request_id: requestId });

export const cancelConnectionRequest = (userId, requestId) =>
  post('cancel', userId, { request_id: requestId });

export const fetchConnectionStatus = (userId, otherId) =>
  post('status', userId, { other_id: otherId });

export const fetchPendingRequestCount = (userId) => post('pending_count', userId);

/**
 * Re-reads premium status from the existing endpoint (it also re-syncs a payment whose return page was closed).
 */
export const refreshPremiumStatus = (userId, userData) => {
  const payload = new FormData();
  payload.append('user_id', userId);
  payload.append('gender', userData?.gender || '');
  payload.append('email', userData?.email || '');
  return axios
    .post(`${process.env.REACT_APP_API_PAYMENT_URL}user/checkpaidprofile`, payload)
    .then((res) => Boolean(res.data?.status || res.data?.is_premium));
};

/** Header listens for this to refresh the pending-requests badge. */
export const REQUESTS_CHANGED_EVENT = 'hs:requests-changed';

export const notifyRequestsChanged = () => {
  window.dispatchEvent(new Event(REQUESTS_CHANGED_EVENT));
};
